// extracted by mini-css-extract-plugin
export default {"btnContainer":"styles_btnContainer__SWUNC"};